import { createContext, useContext } from 'react';
import type { Project } from '../domain/schemas';
import type { ProjectSession } from './projectSession';

export interface ProjectContextValue {
  project: Project;
  session: ProjectSession;
  update: (mutate: (project: Project) => Project) => void;
}

export const ProjectContext = createContext<ProjectContextValue | null>(null);

export function useProject(): ProjectContextValue {
  const value = useContext(ProjectContext);
  if (!value) throw new Error('useProject must be used inside an open project.');
  return value;
}
